export function initialize() {

    let copyUrls = document.querySelectorAll('.copy-url');

    if (!copyUrls) return;

    copyUrls.forEach(copyUrl => {

        let copyUrlButton = copyUrl.querySelector('.copy-url__button');
        let copyUrlMessage = copyUrl.querySelector('.copy-url__message');

        copyUrlButton.addEventListener('click', () => {

            const currentUrl = window.location.href;
            
            navigator.clipboard.writeText(currentUrl).then(() => {

                copyUrlMessage.textContent = "Link copied";
                copyUrlMessage.classList.add('is-visible');

                setTimeout(() => {
                    copyUrlMessage.textContent = "";
                    copyUrlMessage.classList.remove('is-visible');
                }, 4000)

            }).catch(err => {

                console.error('Failed to copy the URL:', err);

            });

        })

    })

}
